import HotOfferModule from '@/components/home-newest/hot-offer/index.vue';
import HotNewsModule from '@/components/home-newest/hot-news/index.vue';
import WegoodsModule from '@/components/wegoods/index.vue';
import LargeMiniBannerModule from '@/components/home-newest/large-mini-banner/index.vue';
// 20260818 下线新人优惠码：保留 import 便于恢复
// import DiscountCodeModule from '@/components/discount-code/index.vue';

// 模块名称，枚举type
export enum ModuleName  {
  'HotOfferModule' = 'HotOfferModule',
  'HotNewsModule' = 'HotNewsModule',
  'WegoodsModule' = 'WegoodsModule',
  'LargeMiniBannerModule' = 'LargeMiniBannerModule',
  'DiscountCodeModule' = 'DiscountCodeModule',
}
export type ModuleConfig = {
  moduleName: ModuleName, // 模块名称
  component: Vue.Component, // 模块对应的视图
  sort: number, // 模块通用排序，数字越大越靠前，範圍（1-99）
  props?: any,
};

/** 通用排序的權重值 */
export const SORT_WEIGHT = 1;

/** 常驻模块的配置 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const commonModuleConfig: Array<ModuleConfig> = [
  {
    moduleName: ModuleName.LargeMiniBannerModule,
    component: LargeMiniBannerModule,
    sort: 99,
  },
  // 20260818 下线新人优惠码：防御性注释
  // {
  //   moduleName: ModuleName.DiscountCodeModule,
  //   component: DiscountCodeModule,
  //   sort: 94,
  //   props: {
  //     class: 'discount-code-new',
  //   },
  // },
  {
    moduleName: ModuleName.HotOfferModule,
    component: HotOfferModule,
    sort: 90,
    props: {
      class: 'info-container',
    },
  },
  {
    moduleName: ModuleName.WegoodsModule,
    component: WegoodsModule,
    sort: 80,
    props: {
      class: 'fit-third-product',
      moduleName: 'discount',
    },
  },
  {
    moduleName: ModuleName.HotNewsModule,
    component: HotNewsModule,
    sort: 70,
    props: {
      class: 'info-container',
    },
  },
];
